import script from "./ListaUsuariosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaUsuariosView.vue?vue&type=script&setup=true&lang=js"

import "./ListaUsuariosView.vue?vue&type=style&index=0&id=15c6ef24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c6ef24"]])

export default __exports__